import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { recentBuyers } from '../data/recentBuyers';
const FIRST_DELAY_MS = 5000;
const INTERVAL_MS = 15000;
const VISIBLE_MS = 5000;
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    let interval: number | undefined;
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, INTERVAL_MS);
    }, FIRST_DELAY_MS);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 right-3 z-40 sm:bottom-5 sm:left-5 sm:right-auto" data-id="element-138" data-mp="1xe7pn07dyssl">
      <AnimatePresence data-id="element-139" data-mp="1ng1rmtopa6t0">
        {visible && !dismissed && <motion.div key={index} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border border-line bg-night/95 py-2.5 pl-2.5 pr-9 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.8)] backdrop-blur sm:max-w-xs" data-id="element-140" data-mp="1ninzyvjf0qca">
            <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold font-display text-sm font-semibold text-ink" data-id="element-141" data-mp="vq5adv79haps">
              {buyer.name.charAt(0)}
            </span>
            <div className="min-w-0 text-left" data-id="element-142" data-mp="2sm9piadqw74v">
              <p className="truncate text-[13px] text-cream" data-id="element-143" data-mp="2nq1ftcibh653">
                <span className="font-semibold" data-id="element-144" data-mp="2jnekv2qcn53o">{buyer.name}</span> de {buyer.city}, {buyer.country}
              </p>
              <p className="text-xs text-muted" data-id="element-145" data-mp="3ge7243p0r371">
                compró <span className="text-gold-light" data-id="element-146" data-mp="3gbkuk424onot">El Libro del Despertar</span>
              </p>
              <p className="mt-0.5 text-[11px] text-muted/80" data-id="element-147" data-mp="3bfdjjwuvkm00">{buyer.time}</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-148" data-mp="37b5w0305lc3d">
              <XIcon className="h-3.5 w-3.5" data-id="element-149" data-mp="6h85e6j75p5q" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}